<template>
  <div class="section card card-contact">
    <p class="subtitle add-contact">
      Ajouter un contact
    </p>
    <div class="columns">
      <div class="column">
        <b-field>
          <b-input
            type="text"
            custom-class="input"
            placeholder="Nom"
            v-model="contactChange.nom"
            tabindex="1">
          </b-input>
        </b-field>
        <br>
        <b-field :type="errorEmail">
          <b-input
            type="email"
            custom-class="input"
            placeholder="Email"
            v-model="contactChange.email"
            tabindex="3">
          </b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field>
          <b-input
            type="text"
            custom-class="input"
            placeholder="Prénom"
            v-model="contactChange.prenom"
            tabindex="2">
          </b-input>
        </b-field>
        <br>
        <b-field>
          <b-input
            type="text"
            custom-class="input"
            placeholder="Téléphone"
            v-model="contactChange.telephone"
            tabindex="4">
          </b-input>
        </b-field>
      </div>
    </div>
    <div class="has-text-centered">
        <button class="button is-primary is-fullwidth has-addons-centered" @click="addContact()"
          tabindex="5">
          Ajouter le contact
        </button>
    </div>
    <br>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as typesPanier from '@/store/creationOpportunite/panier-mutation-type';
import gestionErreur from '@/services/general/gestionErreur';

const Panier = createNamespacedHelpers('panier');

export default {
  name: 'ajout-contact',
  data() {
    return {
      errorEmail: '',
    };
  },
  computed: {
    ...Panier.mapGetters({
      getContactPanier: 'contactPanier',
    }),
    contactChange() {
      if (this.contactPanier) {
        return this.contactPanier;
      }
      return {
        nom: null,
        prenom: null,
        email: null,
        telephone: null,
      };
    },
    contactPanier: {
      get() {
        return this.getContactPanier;
      },
      set(value) {
        this.setContactPanier(value);
      },
    },
  },
  methods: {
    ...Panier.mapMutations({
      setContactPanier: typesPanier.SET_CONTACT_PANIER,
    }),
    addContact() {
      if (this.contactChange.nom ||
        this.contactChange.prenom ||
        this.contactChange.email ||
        this.contactChange.telephone) {
        if (!/.+@.+\..+/.test(this.contactChange.email)) {
          this.errorEmail = 'is-danger';
          gestionErreur('L\'email entrée en incorrecte');
          return;
        }
        this.errorEmail = '';
        this.contactPanier = {
          nom: this.contactChange.nom,
          prenom: this.contactChange.prenom,
          email: this.contactChange.email,
          telephone: this.contactChange.telephone,
        };
      } else {
        gestionErreur('Veuillez renseigner au moins une information pour ajouter un contact');
      }
    },
  },
};
</script>

<style scoped>
  .input {
    margin-bottom: 10px;
    font-size:14px;
  }
  .subtitle {
    font-size:14px;
  }

  .add-contact {
    padding-top: 10px;
  }

  .card-contact {
    background-color: #F2F7FC;
    border-color: #E1E5EC;
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/client/ajoutContact.vue